<app-page-bar></app-page-bar>

<app-page>

  <h2>Import</h2>

  <mat-card>

    <app-card-title title="Payments"></app-card-title>

    <ng-container *ngIf="imports$ | async as imports">

      <p>Imported {{stats.success.count}} ({{stats.success.value | currency:'EUR'}}) payment(s) successfully. Import failed on {{stats.failure.count}} payment(s) ({{stats.failure.value | currency:'EUR'}}).</p>

      <p><mat-checkbox checked="true" (change)="filterChanged()">Show failed only</mat-checkbox></p>

      <mat-divider></mat-divider>

      <mat-table [dataSource]="imports">

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon color="primary" *ngIf="element.success">done</mat-icon>
            <mat-icon color="warn" *ngIf="!element.success">error</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.date | date:'short'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoiceNumber">
          <mat-header-cell *matHeaderCellDef>Invoice Number</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a *ngIf="element.success" [routerLink]="['/invoices', element.invoiceId]" target="_blank">{{element.invoiceNumber}}</a>
            <span *ngIf="!element.success">{{element.invoiceNumber}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="referenceNumber">
          <mat-header-cell *matHeaderCellDef>Reference Number</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.referenceNumber}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.amount | currency:'EUR'}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;"></mat-row>

      </mat-table>

    </ng-container>

    <mat-card-actions align="end">

      <button type="button" [disabled]="importing" mat-button (click)="import()">Import</button>

    </mat-card-actions>

  </mat-card>

</app-page>
